// src/components/PagoWompi.jsx

import React, { useEffect, useMemo, useRef, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import "../styles/pagoWompi.css";

import petfamLogo from "../assets/Petfamp.png";

import wompiLogo from "../assets/Wompi.webp";

import chip from "../assets/chip.webp";

import visa from "../assets/visa.webp";

import mc from "../assets/mastercard.webp";

import amex from "../assets/amex.webp";

import config from "../config";

const API_BASE_URL = String(config.apiBaseUrl || "").replace(/\/+$/, "");

// =========================================================

// 🔌 CÓDIGOS DE DESCUENTO (SW3 de Contacto) — APAGADO

// La validación de códigos consultaba a Contacto, que salió del producto

// (contacto.enabled=false en el backend). Si se dejara prendida, cada

// intento de validar reventaría y BLOQUEARÍA el botón de pagar, porque

// validateForm() exige que el código sea válido antes de continuar.

// No se borró nada: poniendo este flag en true vuelve a funcionar igual.

// =========================================================

const DISCOUNT_CODES_ENABLED = false;

// ✅ Códigos válidos de aliados

const VALID_INFLUENCER_CODES = new Set([

  "LARY",

  "LUISANOMADA",

  "AFGF",

  "SGF1",

  "CHIGUIRO",

  "HUESOS",

  "RG6",

  "PANCHAUX",

  "LAUHOLAHOLA",

  "VANE08",

  "DANNAFAM",

  "JUANPAPET",

  "MELIPETFAM",

  "SILENY",

]);

function normalizeInfluencerCode(raw) {

  return String(raw || "").trim().toUpperCase().replace(/\s+/g, "");

}

function getInfluencerCodeFromSearch(search) {

  const params = new URLSearchParams(search || "");

  const raw =

    params.get("ref") ||

    params.get("codigo") ||

    params.get("code") ||

    "";

  const normalized = normalizeInfluencerCode(raw);

  return VALID_INFLUENCER_CODES.has(normalized) ? normalized : "";

}

/**

 * ✅ Helper: prueba varias rutas y se queda con la que funcione.

 */

async function fetchFirstOkJson(urls, options) {

  let lastErr = null;

  for (const u of urls) {

    try {

      const r = await fetch(u, options);

      if (!r.ok) {

        lastErr = new Error(`HTTP ${r.status} en ${u}`);

        continue;

      }

      const data = await r.json().catch(() => null);

      return { ok: true, url: u, data };

    } catch (e) {

      lastErr = e;

    }

  }

  return { ok: false, error: lastErr || new Error("No hubo respuesta válida.") };

}

// =========================================================

// 🔐 SESIÓN

// Las rutas /plan/** del backend piden token. Aquí se lee la sesión que

// ya guardó el login (o el registro), sin depender de otros archivos.

// =========================================================

function getStoredToken() {

  try {

    return localStorage.getItem("token") || "";

  } catch {

    return "";

  }

}

function readStoredUser() {

  try {

    const raw = localStorage.getItem("petfamUser");

    return raw ? JSON.parse(raw) : null;

  } catch {

    return null;

  }

}

function getStoredUserId() {

  const u = readStoredUser();

  const id = u?.idUser ?? u?.id ?? u?.userId ?? null;

  if (id != null) return Number(id);

  try {

    const fallback = localStorage.getItem("idUser");

    return fallback ? Number(fallback) : null;

  } catch {

    return null;

  }

}

/** fetch con token, devolviendo status + body (no lanza por status). */

async function authJson(url, options = {}) {

  const token = getStoredToken();

  const res = await fetch(url, {

    ...options,

    headers: {

      "Content-Type": "application/json",

      ...(token ? { Authorization: `Bearer ${token}` } : {}),

      ...(options.headers || {}),

    },

  });

  const data = await res.json().catch(() => null);

  return { status: res.status, ok: res.ok, data };

}

// ✅ Plan base en COP

const PLAN_INFO = {

  mensual: { label: "MENSUAL", priceCop: 19900 },

};

function normalizeCardHolder(value) {

  return value

    .replace(/[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ\s]/g, "")

    .toUpperCase()

    .replace(/\s+/g, " ")

    .trimStart();

}

function normalizePlan(raw) {

  const v = String(raw || "").trim().toLowerCase();

  return v === "mensual" ? "mensual" : "mensual";

}

function onlyDigits(v, maxLen) {

  return String(v || "").replace(/\D/g, "").slice(0, maxLen);

}

function formatCardNumber(value) {

  const digits = String(value || "").replace(/\D/g, "").slice(0, 16);

  return digits.replace(/(\d{4})(?=\d)/g, "$1 ").trim();

}

function sleep(ms) {

  return new Promise((r) => setTimeout(r, ms));

}

function formatMoney(amount, currency) {

  const n = Number(amount || 0);

  if (currency === "COP") {

    const base = new Intl.NumberFormat("es-CO", {

      style: "currency",

      currency: "COP",

      maximumFractionDigits: 0,

    }).format(n);

    const clean = base.replace(/\u00A0/g, " ").replace(/\s+/g, " ").trim();

    return `${clean} COP`;

  }

  const base = new Intl.NumberFormat("en-US", {

    style: "currency",

    currency: "USD",

    minimumFractionDigits: 2,

    maximumFractionDigits: 2,

  }).format(n);

  const clean = base.replace(/\u00A0/g, " ").replace(/\s+/g, " ").trim();

  return `${clean} USD`;

}

function toCents(amount) {

  return Math.round(Number(amount) * 100);

}

/**

 * El backend manda las fechas como texto ("2026-09-19T14:03:00") o como

 * arreglo ([2026, 9, 19, 14, 3]), según cómo serialice Jackson. Esto

 * entiende las dos y devuelve un Date, o null si no se puede leer.

 */

function parseServerDate(value) {

  if (!value) return null;

  if (Array.isArray(value)) {

    const [y, mo, d, h = 0, mi = 0] = value;

    if (!y || !mo || !d) return null;

    return new Date(y, mo - 1, d, h, mi);

  }

  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);

  if (!m) return null;

  return new Date(

    Number(m[1]),

    Number(m[2]) - 1,

    Number(m[3]),

    Number(m[4] || 0),

    Number(m[5] || 0)

  );

}

/** "19 de septiembre" */

function formatDayMonth(date) {

  if (!date) return "";

  return date.toLocaleDateString("es-CO", { day: "numeric", month: "long" });

}

export default function PagoWompi() {

  const location = useLocation();

  const nav = useNavigate();

  const planId = normalizePlan(

    location.state?.planId || localStorage.getItem("petfam_selected_plan") || "mensual"

  );

  const planMeta = PLAN_INFO[planId] || PLAN_INFO.mensual;

  const email =

    location.state?.email ||

    localStorage.getItem("petfam_customer_email") ||

    localStorage.getItem("userEmail") ||

    "";

  // ✅ Leer draft del signup (si existe)

  const signupDraft = useMemo(() => {

    const fromState = location.state?.signupDraft || null;

    if (fromState) return fromState;

    try {

      const raw = localStorage.getItem("petfam_signup_draft");

      return raw ? JSON.parse(raw) : null;

    } catch {

      return null;

    }

  }, [location.state?.signupDraft]);

  const initialInfluencerCode = useMemo(() => {

    const fromState = normalizeInfluencerCode(location.state?.influencerCode || "");

    if (fromState && VALID_INFLUENCER_CODES.has(fromState)) return fromState;

    const fromDraft = normalizeInfluencerCode(signupDraft?.influencerCode || "");

    if (fromDraft && VALID_INFLUENCER_CODES.has(fromDraft)) return fromDraft;

    const fromSearch = getInfluencerCodeFromSearch(location.search);

    if (fromSearch) return fromSearch;

    const fromStorage = normalizeInfluencerCode(

      localStorage.getItem("petfam_influencer_code") ||

      sessionStorage.getItem("petfam_influencer_code") ||

      ""

    );

    if (fromStorage && VALID_INFLUENCER_CODES.has(fromStorage)) return fromStorage;

    return "";

  }, [location.state?.influencerCode, location.search, signupDraft]);

  // =========================

  // ✅ GEOIP (fallback)

  // =========================

  const [geoCountry, setGeoCountry] = useState(""); // "CO" | "EC" | "UN"

  useEffect(() => {

    const run = async () => {

      try {

        const urls = [

          `${API_BASE_URL}/geo/country`,

          `${API_BASE_URL}/api/geo/country`,

        ];

        const res = await fetchFirstOkJson(urls, { cache: "no-store" });

        if (!res.ok) {

          setGeoCountry("UN");

          return;

        }

        const c = String(res.data?.country || "UN").toUpperCase();

        setGeoCountry(c === "CO" || c === "EC" ? c : "UN");

      } catch {

        setGeoCountry("UN");

      }

    };

    run();

  }, []);

  // ✅ País final: prioridad draft -> geo -> CO (por defecto)

  const country = String(

    signupDraft?.customer?.country || geoCountry || "CO"

  ).toUpperCase();

  const currency = country === "EC" ? "USD" : "COP";

  // ✅ Precio USD (tu UI)

  const PRICE_USD = 2.99;

  // =========================================================

  // 🎁 ESTADO DEL PLAN (prueba de 7 días)

  // Define TODO el comportamiento de esta pantalla:

  //  - planStatus === "TRIAL"  -> la tarjeta se guarda y NO se cobra nada.

  //    El primer cobro sale solo el día en que se acaba la prueba.

  //  - cualquier otro caso     -> cobro inmediato, igual que siempre.

  // =========================================================

  const [planInfo, setPlanInfo] = useState(null);

  const [planLoaded, setPlanLoaded] = useState(false);

  const userId = useMemo(() => getStoredUserId(), []);

  const hasSession = !!userId && !!getStoredToken();

  useEffect(() => {

    let cancelled = false;

    const loadPlan = async () => {

      if (!userId || !getStoredToken()) {

        setPlanLoaded(true);

        return;

      }

      try {

        const res = await authJson(`${API_BASE_URL}/plan/status?idUser=${userId}`, {

          method: "GET",

          cache: "no-store",

        });

        if (cancelled) return;

        if (res.ok && res.data?.data) {

          setPlanInfo(res.data.data);

        }

      } catch {

        // Si no se pudo consultar, se sigue con el cobro inmediato de siempre.

      } finally {

        if (!cancelled) setPlanLoaded(true);

      }

    };

    loadPlan();

    return () => {

      cancelled = true;

    };

  }, [userId]);

  // ⚠️ FLUJO FINAL: el cobro es SIEMPRE inmediato. Ya no existe el modo

  // "guardar la tarjeta sin cobrar": al activar el plan Pro se cobra y,

  // con la aprobación de Wompi, se desbloquea todo.

  const isTrialMode = false;

  const trialEndDate = useMemo(

    () => parseServerDate(planInfo?.trialEndsAt),

    [planInfo?.trialEndsAt]

  );

  const [cardType, setCardType] = useState("visa");

  const [discountCode, setDiscountCode] = useState(initialInfluencerCode);

  const [acceptedWompiTerms, setAcceptedWompiTerms] = useState(false);

  const [acceptedPetfamTerms, setAcceptedPetfamTerms] = useState(false);

  // ===== SW3 (frontend) =====

  const [inflChecking, setInflChecking] = useState(false);

  const [inflValid, setInflValid] = useState(false);

  const [inflName, setInflName] = useState("");

  const [inflMsg, setInflMsg] = useState("");

  const sw3AbortRef = useRef(null);

  const sw3DebounceRef = useRef(null);

  const payingRef = useRef(false);

  const [card, setCard] = useState({

    card_holder: "",

    number: "",

    exp_month: "",

    exp_year: "",

    cvc: "",

  });

  const cardLogo = cardType === "visa" ? visa : cardType === "mc" ? mc : amex;

  const shownNumber = card.number ? formatCardNumber(card.number) : "1234 5678 9012 3456";

  const shownName = card.card_holder?.trim() ? card.card_holder : "CARDHOLDER NAME";

  const shownExp = `${card.exp_month || "MM"}/${card.exp_year || "YY"}`;

  const hasValidCode =

    DISCOUNT_CODES_ENABLED && inflValid && normalizeInfluencerCode(discountCode).length > 0;

  const shownAmount = useMemo(() => {

    if (currency === "USD") {

      const base = PRICE_USD;

      const discounted = base * 0.9;

      return hasValidCode ? Math.round(discounted * 100) / 100 : base;

    }

    const baseCop = planMeta.priceCop;

    const discountedCop = 17910;

    return hasValidCode ? discountedCop : baseCop;

  }, [currency, hasValidCode, planMeta.priceCop]);

  const hasDiscountApplied =

    hasValidCode &&

    ((currency === "COP" && shownAmount === 17910) ||

      (currency === "USD" && shownAmount !== PRICE_USD));

  const [merchant, setMerchant] = useState(null);

  const [booting, setBooting] = useState(true);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const [step, setStep] = useState("");

  const [success, setSuccess] = useState(false);

  const showProcessingModal = loading;

  // ✅ Mantener código influencer sincronizado

  useEffect(() => {

    if (initialInfluencerCode) {

      localStorage.setItem("petfam_influencer_code", initialInfluencerCode);

      sessionStorage.setItem("petfam_influencer_code", initialInfluencerCode);

      return;

    }

    const stored = normalizeInfluencerCode(

      localStorage.getItem("petfam_influencer_code") ||

      sessionStorage.getItem("petfam_influencer_code") ||

      ""

    );

    if (stored && !VALID_INFLUENCER_CODES.has(stored)) {

      localStorage.removeItem("petfam_influencer_code");

      sessionStorage.removeItem("petfam_influencer_code");

    }

  }, [initialInfluencerCode]);

  async function fetchMerchantFresh() {

    const urls = [`${API_BASE_URL}/wompi/merchant`, `${API_BASE_URL}/api/wompi/merchant`];

    const res = await fetchFirstOkJson(urls, { cache: "no-store" });

    if (!res.ok) throw new Error("No pude obtener merchant/tokens desde el backend.");

    const data = res.data;

    if (!data?.publicKey) throw new Error("Merchant no trajo publicKey.");

    if (!data?.acceptance?.token) throw new Error("Merchant no trajo acceptance.token.");

    if (!data?.personalData?.token) throw new Error("Merchant no trajo personalData.token.");

    setMerchant(data);

    return data;

  }

  useEffect(() => {

    if (!email) {

      nav("/crear-cuenta");

      return;

    }

    const boot = async () => {

      try {

        setBooting(true);

        setError("");

        setStep("Cargando configuración de Wompi...");

        await fetchMerchantFresh();

        setStep("");

      } catch (e) {

        setError(e?.message || "Error iniciando pagos.");

      } finally {

        setBooting(false);

      }

    };

    boot();

  }, [email, nav]);

  // =========================

  // ✅ SW3: validar influencer

  // (apagado mientras DISCOUNT_CODES_ENABLED sea false)

  // =========================

  useEffect(() => {

    if (!DISCOUNT_CODES_ENABLED) return;

    const code = normalizeInfluencerCode(discountCode);

    if (!code) {

      setInflChecking(false);

      setInflValid(false);

      setInflName("");

      setInflMsg("");

      if (sw3DebounceRef.current) clearTimeout(sw3DebounceRef.current);

      if (sw3AbortRef.current) sw3AbortRef.current.abort();

      return;

    }

    setDiscountCode(code);

    localStorage.setItem("petfam_influencer_code", code);

    sessionStorage.setItem("petfam_influencer_code", code);

    if (sw3DebounceRef.current) clearTimeout(sw3DebounceRef.current);

    sw3DebounceRef.current = setTimeout(async () => {

      try {

        setInflChecking(true);

        setInflMsg("Verificando código...");

        setInflValid(false);

        setInflName("");

        if (sw3AbortRef.current) sw3AbortRef.current.abort();

        const ac = new AbortController();

        sw3AbortRef.current = ac;

        const urls = [

          `${API_BASE_URL}/contacto/getinfluencer/${encodeURIComponent(code)}`,

          `${API_BASE_URL}/api/contacto/getinfluencer/${encodeURIComponent(code)}`,

          `${API_BASE_URL}/contacto/getinfluencer?codigo=${encodeURIComponent(code)}`,

          `${API_BASE_URL}/api/contacto/getinfluencer?codigo=${encodeURIComponent(code)}`,

        ];

        const res = await fetchFirstOkJson(urls, {

          method: "GET",

          signal: ac.signal,

          cache: "no-store",

        });

        if (!res.ok) {

          setInflValid(false);

          setInflName("");

          setInflMsg("No pudimos validar el código ahora.");

          return;

        }

        const out = res.data || {};

        const datos = out?.datos || out?.data || {};

        const exists = datos && Object.keys(datos).length > 0;

        const nombre = datos?.nombre || datos?.name || datos?.nombres || datos?.Nombre || "";

        if (exists) {

          setInflValid(true);

          setInflName(String(nombre || "").trim());

          setInflMsg("Código válido ✅");

        } else {

          setInflValid(false);

          setInflName("");

          setInflMsg("Código no existe.");

        }

      } catch (e) {

        if (e?.name === "AbortError") return;

        setInflValid(false);

        setInflName("");

        setInflMsg("No pudimos validar el código ahora.");

      } finally {

        setInflChecking(false);

      }

    }, 450);

    return () => {

      if (sw3DebounceRef.current) clearTimeout(sw3DebounceRef.current);

    };

  }, [discountCode]);

  function validateForm() {

    if (!email) return "No tengo el email del usuario. Vuelve a registrarte.";

    if (!merchant?.publicKey) return "No tengo la publicKey de Wompi.";

    if (!merchant?.acceptance?.token) return "No tengo acceptance.token.";

    if (!merchant?.personalData?.token) return "No tengo personalData.token.";

    if (!acceptedWompiTerms) return "Debes aceptar los términos de Wompi para continuar.";

    if (!acceptedPetfamTerms) return "Debes aceptar los términos y políticas de Petfam para continuar.";

    if (!card.card_holder.trim()) return "Escribe el nombre del titular.";

    const num = onlyDigits(card.number, 16);

    if (num.length < 13) return "Número de tarjeta incompleto.";

    const mm = onlyDigits(card.exp_month, 2);

    const yy = onlyDigits(card.exp_year, 2);

    if (mm.length !== 2) return "Mes inválido.";

    if (yy.length !== 2) return "Año inválido.";

    const cvc = onlyDigits(card.cvc, 4);

    if (cvc.length < 3) return "CVV inválido.";

    // Con los códigos apagados, un código viejo guardado en el navegador

    // NUNCA puede bloquear el pago.

    if (DISCOUNT_CODES_ENABLED) {

      const code = normalizeInfluencerCode(discountCode);

      if (code && inflChecking) return "Espera: estamos verificando el código de descuento.";

      if (code && !inflValid) return "El código de descuento no es válido. Corrígelo o déjalo vacío.";

    }

    return null;

  }

  async function tokenizeCard(merchantSnap) {

    const pubKey = merchantSnap.publicKey;

    const body = {

      number: onlyDigits(card.number, 16),

      cvc: onlyDigits(card.cvc, 4),

      exp_month: onlyDigits(card.exp_month, 2),

      exp_year: onlyDigits(card.exp_year, 2),

      card_holder: card.card_holder.trim(),

    };

    const wompiBase =

      String(pubKey || "").startsWith("pub_prod_")

        ? "https://production.wompi.co/v1"

        : "https://sandbox.wompi.co/v1";

    const r = await fetch(`${wompiBase}/tokens/cards`, {

      method: "POST",

      headers: {

        "Content-Type": "application/json",

        Authorization: `Bearer ${pubKey}`,

      },

      body: JSON.stringify(body),

    });

    const data = await r.json().catch(() => null);

    if (!r.ok) {

      const msg =

        data?.error?.reason ||

        data?.error?.messages?.[0] ||

        data?.message ||

        "Error tokenizando tarjeta en Wompi.";

      throw new Error(msg);

    }

    const token = data?.data?.id;

    if (!token) throw new Error("Wompi no devolvió token de tarjeta (tok_test_...).");

    return token;

  }

  async function createPaymentSource(tokCard, merchantSnap) {

    const payload = {

      token: tokCard,

      customerEmail: email,

      acceptanceToken: merchantSnap.acceptance.token,

      acceptPersonalAuthToken: merchantSnap.personalData.token,

    };

    const urls = [

      `${API_BASE_URL}/wompi/payment-sources/card`,

      `${API_BASE_URL}/api/wompi/payment-sources/card`,

    ];

    const res = await fetchFirstOkJson(urls, {

      method: "POST",

      headers: { "Content-Type": "application/json" },

      body: JSON.stringify(payload),

    });

    if (!res.ok || !res.data?.ok) {

      throw new Error(res.data?.message || "No pude crear la fuente de pago.");

    }

    const psId = res.data?.data?.paymentSourceId;

    if (!psId) throw new Error("Backend no devolvió paymentSourceId.");

    return psId;

  }



  async function createTransaction(paymentSourceId, merchantSnap) {

    const code = normalizeInfluencerCode(discountCode);

    const amountInCents = toCents(shownAmount);

    const payload = {

      paymentSourceId: Number(paymentSourceId),

      customerEmail: email,

      discountCode: DISCOUNT_CODES_ENABLED && code && inflValid ? code : null,

      acceptanceToken: merchantSnap.acceptance.token,

      acceptPersonalAuthToken: merchantSnap.personalData.token,

      installments: 1,

      currency,

      amountInCents,

      country,

      planId,

    };

    const urls = [

      `${API_BASE_URL}/wompi/transactions/charge`,

      `${API_BASE_URL}/api/wompi/transactions/charge`,

    ];

    const res = await fetchFirstOkJson(urls, {

      method: "POST",

      headers: { "Content-Type": "application/json" },

      body: JSON.stringify(payload),

    });

    if (!res.ok || !res.data?.ok) {

      throw new Error(res.data?.message || "No pude crear la transacción.");

    }

    const txId = res.data?.transactionId;

    if (!txId) throw new Error("Backend no devolvió transactionId.");

    return txId;

  }

  async function pollStatusUntilFinal(txId) {

    const urls = [

      `${API_BASE_URL}/wompi/transactions/status/${txId}`,

      `${API_BASE_URL}/api/wompi/transactions/status/${txId}`,

    ];

    const maxTries = 20;

    for (let i = 0; i < maxTries; i++) {

      await sleep(2000);

      const res = await fetchFirstOkJson(urls, { method: "GET", cache: "no-store" });

      if (res.ok && res.data?.ok) {

        const st = String(res.data?.status || "").toUpperCase();

        if (st === "APPROVED") return "APPROVED";

        if (st === "DECLINED" || st === "ERROR" || st === "VOIDED") return st;

      }

    }

    return "PENDING";

  }

  /** Cobro inmediato de siempre (prueba vencida, mora o reactivación). */

  async function chargeNow(paymentSourceId, merchantSnap) {

    setStep("Creando transacción...");

    const txId = await createTransaction(paymentSourceId, merchantSnap);

    setStep("Confirmando estado...");

    const finalStatus = await pollStatusUntilFinal(txId);

    if (finalStatus === "APPROVED") {

      setStep("");


      setSuccess(true);

      return;

    }

    if (finalStatus === "DECLINED" || finalStatus === "ERROR" || finalStatus === "VOIDED") {

      setStep("");

      try {

        await fetchMerchantFresh();

      } catch (_) {}

      throw new Error(`Pago ${finalStatus}. Intenta con otra tarjeta.`);

    }

    setStep("");

    try {

      await fetchMerchantFresh();

    } catch (_) {}

    throw new Error(

      "Tu pago está en proceso. Si ya te salió éxito en Wompi, el sistema lo confirmará en segundos."

    );

  }

  async function handlePay() {

    if (payingRef.current) return;

    payingRef.current = true;

    const msg = validateForm();

    if (msg) {

      setError(msg);

      payingRef.current = false;

      return;

    }

    setLoading(true);

    setError("");

    setSuccess(false);

    try {

      setStep("Preparando tokens...");

      const merchantSnap = await fetchMerchantFresh();

      setStep("Tokenizando tarjeta...");

      const tokCard = await tokenizeCard(merchantSnap);

      setStep("Creando fuente de pago...");

      const paymentSourceId = await createPaymentSource(tokCard, merchantSnap);

      // =================================================================

      // 🎁 EN PRUEBA: se guarda la tarjeta y NO se cobra nada.

      // Si el backend responde que la prueba ya venció, cae solo al

      // cobro inmediato de siempre.

      // =================================================================

      await chargeNow(paymentSourceId, merchantSnap);

    } catch (e) {

      const msg = e?.message || "Error procesando pago.";

      try {

        await fetchMerchantFresh();

      } catch (_) {}

      setError(msg);

    } finally {

      setLoading(false);

      payingRef.current = false;

    }

  }

  /** A dónde vuelve la persona al terminar (o al tocar la flecha atrás). */

  const goBackHome = () => {

    if (hasSession) nav("/interfaz");

    else nav("/crear-cuenta");

  };

  const inflCodeClean = normalizeInfluencerCode(discountCode);

  const termsPermalink = merchant?.acceptance?.permalink || "";

  const personalPermalink = merchant?.personalData?.permalink || "";

  const allTermsAccepted = acceptedWompiTerms && acceptedPetfamTerms;

  const trialEndLabel = formatDayMonth(trialEndDate);

  const priceLabel = formatMoney(shownAmount, currency);

  return (

    <div className="pw-fullscreen">

      {showProcessingModal ? (

        <div className="pw-modal-overlay" role="dialog" aria-modal="true" aria-label="Procesando">

          <div className="pw-modal">

            <p className="pw-modal-title">{isTrialMode ? "Guardando..." : "Procesando..."}</p>

            <p className="pw-modal-subtitle">{step ? step : "Por favor espera un momento."}</p>

          </div>

        </div>

      ) : null}

      {success ? (
        <div
          className="pw-modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Pago aprobado"
        >
          <div className="pw-modal">
            <p className="pw-modal-title">Pago aprobado ✅</p>
            <p className="pw-modal-subtitle">
              Disfruta de Petfam con todas sus funciones completas.
            </p>
            <button
              className="pw-pay"
              type="button"
              onClick={() => nav("/interfaz")}
            >
              OK
            </button>
          </div>
        </div>
      ) : null}

      <div className="pw-shell">

        <button

          type="button"

          className="pw-back"

          onClick={goBackHome}

          aria-label="Volver"

          disabled={loading}

        >

          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />

          </svg>

        </button>

        <div className="pw-header">

          <img src={petfamLogo} alt="Petfam" />

          <span className="pw-x">x</span>

          <img src={wompiLogo} alt="Wompi" />

        </div>

        <div className="pw-layout">

          <div className="pw-left">

            <div className="pw-card-stack">

              <div className="pw-card-back" aria-hidden="true" />

              <div className="pw-card-front">

                <img src={chip} className="pw-chip" alt="Chip" />

                <img src={cardLogo} className="pw-type-logo" alt="Card type" />

                <div className="pw-card-number">{shownNumber}</div>

                <div className="pw-card-footer">

                  <span className="pw-card-name">{shownName}</span>

                  <span className="pw-card-exp">{shownExp}</span>

                </div>

              </div>

            </div>

            <div className="pw-support">

              Si tienes problemas con tu pago, contáctanos a{" "}

              <a href="mailto:soporte@petfam.club">soporte@petfam.club</a> y te ayudaremos a resolverlo.

            </div>

          </div>

          <div className="pw-right">
            <h2 className="pw-title">

              {isTrialMode ? "Activa tu plan Pro" : "Detalles del pago"}

            </h2>

            {booting || !planLoaded ? <div className="pw-hint">Cargando configuración...</div> : null}

            {!booting && merchant?.publicKey ? (

              <div className="pw-hint">

                Pago 100% seguro con Wompi.

                <br />

                Tu información está protegida y cifrada.

              </div>

            ) : null}
            {DISCOUNT_CODES_ENABLED && initialInfluencerCode ? (

              <div className="pw-hint" style={{ marginBottom: 10 }}>

                Código aplicado desde enlace: <b>{initialInfluencerCode}</b>

              </div>

            ) : null}

            {error ? <div className="pw-error">{error}</div> : null}


                <div className="pw-types" role="tablist" aria-label="Tipo de tarjeta">

                  <button

                    type="button"

                    className={`pw-type-btn ${cardType === "visa" ? "active" : ""}`}

                    onClick={() => setCardType("visa")}

                    disabled={loading}

                  >

                    <img src={visa} alt="Visa" loading="lazy" />

                  </button>

                  <button

                    type="button"

                    className={`pw-type-btn ${cardType === "mc" ? "active" : ""}`}

                    onClick={() => setCardType("mc")}

                    disabled={loading}

                  >

                    <img src={mc} alt="Mastercard" loading="lazy" />

                  </button>

                  <button

                    type="button"

                    className={`pw-type-btn ${cardType === "amex" ? "active" : ""}`}

                    onClick={() => setCardType("amex")}

                    disabled={loading}

                  >

                    <img src={amex} alt="American Express" loading="lazy" />

                  </button>

                </div>

                <label className="pw-label">Nombre y apellido del titular</label>

                <input

                  className="pw-input"

                  value={card.card_holder}

                  onChange={(e) => setCard((s) => ({ ...s, card_holder: normalizeCardHolder(e.target.value) }))}

                  placeholder="Tu nombre"

                  autoComplete="cc-name"

                  disabled={loading}

                />

                <label className="pw-label">Número de tarjeta</label>

                <input

                  className="pw-input"

                  value={card.number}

                  onChange={(e) => setCard((s) => ({ ...s, number: formatCardNumber(e.target.value) }))}

                  placeholder="4242 4242 4242 4242"

                  inputMode="numeric"

                  autoComplete="cc-number"

                  disabled={loading}

                />

                <div className="pw-grid">

                  <div>

                    <label className="pw-label">Mes</label>

                    <input

                      className="pw-input"

                      value={card.exp_month}

                      onChange={(e) => setCard((s) => ({ ...s, exp_month: onlyDigits(e.target.value, 2) }))}

                      placeholder="MM"

                      inputMode="numeric"

                      autoComplete="cc-exp-month"

                      disabled={loading}

                    />

                  </div>

                  <div>

                    <label className="pw-label">Año</label>

                    <input

                      className="pw-input"

                      value={card.exp_year}

                      onChange={(e) => setCard((s) => ({ ...s, exp_year: onlyDigits(e.target.value, 2) }))}

                      placeholder="YY"

                      inputMode="numeric"

                      autoComplete="cc-exp-year"

                      disabled={loading}

                    />

                  </div>

                  <div>

                    <label className="pw-label">CVV</label>

                    <input

                      className="pw-input"

                      value={card.cvc}

                      onChange={(e) => setCard((s) => ({ ...s, cvc: onlyDigits(e.target.value, 4) }))}

                      placeholder="CVV"

                      inputMode="numeric"

                      autoComplete="cc-csc"

                      disabled={loading}

                    />

                  </div>

                  <div className="pw-influencer" style={{ display: "none" }}>

                    {/* ⏸️ Oculto temporalmente por indicación del cliente — la lógica sigue intacta, solo se reactiva quitando este style y poniendo DISCOUNT_CODES_ENABLED en true. */}

                    <label className="pw-label">Código de descuento (opcional)</label>

                    <input

                      className="pw-input"

                      placeholder="codigo"

                      value={discountCode}

                      onChange={(e) => setDiscountCode(normalizeInfluencerCode(e.target.value))}

                      disabled={loading}

                    />

                    {inflCodeClean ? (

                      <div className="pw-hint" style={{ marginTop: 6 }}>

                        {inflChecking ? (

                          <span>Verificando…</span>

                        ) : inflValid ? (

                          <span>

                            Código válido ✅ {inflName ? `(${inflName})` : ""}

                          </span>

                        ) : (

                          <span>{inflMsg || "Código no válido."}</span>

                        )}

                      </div>

                    ) : null}

                  </div>

                </div>

                <div className="pw-price">

                  {isTrialMode ? (

                    <>

                      Hoy pagas: <b>{formatMoney(0, currency)}</b>

                      <div className="pw-hint" style={{ marginTop: 6 }}>

                        {trialEndLabel

                          ? `Después: ${priceLabel} al mes, a partir del ${trialEndLabel}.`

                          : `Después: ${priceLabel} al mes.`}

                      </div>

                    </>

                  ) : (

                    <>

                      Importe: <b>{priceLabel}</b>

                      {hasDiscountApplied ? (

                        <div className="pw-discount-msg">

                          ¡Descuento aplicado del 10%!

                        </div>

                      ) : null}

                    </>

                  )}

                </div>

                <label className="pw-terms">

                  <input

                    type="checkbox"

                    checked={acceptedWompiTerms}

                    onChange={(e) => setAcceptedWompiTerms(e.target.checked)}

                    disabled={loading}

                  />

                  <span>

                    Acepto los{" "}

                    {termsPermalink ? (

                      <a href={termsPermalink} target="_blank" rel="noreferrer">

                        términos y condiciones

                      </a>

                    ) : (

                      <span className="pw-terms-muted">términos y condiciones</span>

                    )}{" "}

                    y autorizo el{" "}

                    {personalPermalink ? (

                      <a href={personalPermalink} target="_blank" rel="noreferrer">

                        tratamiento de datos personales

                      </a>

                    ) : (

                      <span className="pw-terms-muted">tratamiento de datos personales</span>

                    )}{" "}

                    de Wompi.

                  </span>

                </label>

                <label className="pw-terms">

                  <input

                    type="checkbox"

                    checked={acceptedPetfamTerms}

                    onChange={(e) => setAcceptedPetfamTerms(e.target.checked)}

                    disabled={loading}

                  />

                  <span>

                    Acepto los{" "}

                    <a href="/terminos" target="_blank" rel="noreferrer">

                      términos y condiciones

                    </a>{" "}

                    y la{" "}

                    <a href="/privacidad" target="_blank" rel="noreferrer">

                      política de tratamiento de datos personales

                    </a>{" "}

                    de Vetia Group S.A.S (Petfam).

                  </span>

                </label>

                <button

                  className="pw-pay"

                  type="button"

                  onClick={handlePay}

                  disabled={booting || loading || !planLoaded || !allTermsAccepted}

                  title={

                    !acceptedWompiTerms

                      ? "Debes aceptar los términos de Wompi."

                      : !acceptedPetfamTerms

                      ? "Debes aceptar los términos y políticas de Petfam."

                      : ""

                  }

                >

                  {isTrialMode ? "Guardar tarjeta" : "Pagar"}

                </button>


          </div>

        </div>
      </div>

    </div>

  );

}